// extracted by mini-css-extract-plugin
export var label = "_dx-1";
export var reminder = "_dx-0";